import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Provider } from 'react-redux';
import store, { persistor } from './redux/store';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { PersistGate } from 'redux-persist/integration/react';
// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

if (process.env.REACT_APP_ENABLE_MOCKS === 'true') {
  // const { worker } = require('./mocks/browser')
  // worker.start({
  //   onUnhandledRequest: 'bypass', // Don't warn about unhandled requests
  // })


  const { default: worker } = await import('./mocks/browser')
  await worker.start({
    serviceWorker: {
      url: '/mockServiceWorker.js'
    }
  })
}

async function prepare() {
  if (process.env.NODE_ENV === 'development') {
    // Removed the mock service worker initialization from here
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));

prepare().then(() => {
  root.render(
    <React.StrictMode>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <Elements stripe={stripePromise}>
            <App />
          </Elements>
        </PersistGate>
      </Provider>
    </React.StrictMode>
  );
}).catch(error => {
  console.error('Failed to start MSW:', error);
  // Still render the app even if MSW fails
  root.render(
    <React.StrictMode>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <App />
        </PersistGate>
      </Provider>
    </React.StrictMode>
  );
});
